import { Center, Text, VStack } from "@chakra-ui/react";
import { ReactNode } from "react";
import ITitle from "./ITitle";

export function InitialStateMessage({
  text,
  message,
  children,
}: {
  text: string;
  message: string;
  children: ReactNode;
}) {
  return (
    <Center height="70vh" width="100%" bg="white" rounded="md" mx="3">
      <VStack spacing={5} maxWidth="250px">
        <ITitle title={text} fontWeight="600" />
        <Text fontSize="14px" textAlign="center" wordBreak="normal">
          {message}
        </Text>
        {children}
      </VStack>
    </Center>
  );
}
